module.exports = __webpack_public_path__ + "img/Vincent.8502022c.jpeg";